import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import MultiSelectInput from "common/multiSelectInput";
import InputField from "common/customInputField";
import Button from "react-bootstrap/Button";
import Modal from "common/modal";
import CustomTooltip from "common/tooltip";
import ProductLookup from "common/productLookup";
import CutSheet from "./cutSheets";
import CutMeasurements from "./cutMeasurements";
import { getProductsObject } from "utils/common";
import { generateUUID } from "utils/common";
import roomIcon from "svg/rooms.svg";
import addIcon from "svg/add.svg";
import alertIcon from "svg/red-alert-icon.svg";
import imagePlaceHolder from "svg/imagePlaceholder.svg";
import deleteIconBlue from "svg/delete_blue.svg";
import editIcon from "svg/edit_blue.svg";
import historyIcon from "svg/history.svg";
import {
  getlaborCodeOptions,
  addLaborCodeForProduct,
  deleteLaborCodeForProduct,
  updateProduct,
  removeProduct,
  addProduct,
  getSiteDetails,
  submitCreateNewSite,
} from "store/siteRepo/actionCreator";
import axios from "services/config";
import { editSiteProductLaborCode } from "store/slices/siteRepo";
import uniqBy from "lodash/uniqBy";
import sortBy from "lodash/sortBy";
import { toast } from "react-toastify";

const ProductLaborCodeRow = ({ layer, product, laborCodeItem, territoryAccess }) => {
  const { siteId } = useParams();
  const { sub } = useSelector((state) => state.loggedInUser);
  const dispatch = useDispatch();

  const [showEditLaborCodeModal, setShowEditLaborCodeModal] = useState(false);
  const [showDeleteLaborCodeModal, setShowDeleteLaborCodeModal] = useState(false);
  const [quantity, setQuantity] = useState(laborCodeItem.quantity ?? "NA");
  const [description, setDescription] = useState(laborCodeItem.laborCodeModDesc ?? laborCodeItem.laborCodeDesc ?? "NA");
  const [isTaxable, setIsTaxable] = useState(laborCodeItem.isTaxable);

  useEffect(() => {
    setQuantity(laborCodeItem.quantity);
  }, [laborCodeItem.quantity]);

  useEffect(() => {
    setDescription(laborCodeItem.laborCodeModDesc ?? laborCodeItem.laborCodeDesc ?? "NA");
  }, [laborCodeItem.laborCodeModDesc ?? laborCodeItem.laborCodeDesc]);

  useEffect(() => {
    setIsTaxable(laborCodeItem.isTaxable);
  }, [laborCodeItem.isTaxable]);

  const roomIds = product.rooms.map((r) => r.roomId);
  const siteLaborCodeIds = layer.rooms
    .filter((r) => roomIds.includes(r.roomId))
    .flatMap((r) => r.products)
    .flatMap((p) => p.siteLaborCodes)
    .filter((lc) => lc.laborCode === laborCodeItem.laborCode)
    .map((lc) => lc.siteLaborCodeId);

  return (
    <div className="d-flex align-items-center py-4" style={{ borderBottom: "1px solid #d1d1d1" }}>
      <div className="labor-codes-table-row-cell info-item" style={{ borderRight: "1px solid #d1d1d1" }}>
        {laborCodeItem.laborCode}
      </div>
      <div
        className="labor-codes-table-row-cell cursor-pointer info-item pl-20px"
        style={{ borderRight: "1px solid #d1d1d1", width: "450px" }}
      >
        <CustomTooltip
          placement="top"
          trigger="hover"
          text={`${laborCodeItem.laborCode}- ${description}: ${laborCodeItem.laborCodeDescExt}`}
        >
          {description}
        </CustomTooltip>
      </div>
      <div
        className="labor-codes-table-row-cell info-item ml-20px d-flex align-items-center"
        style={{ borderRight: "1px solid #d1d1d1", width: "120px" }}
      >
        <span style={{ fontSize: "12px", fontWeight: 700, marginRight: "10px" }}>Quantity:</span>
        <span className={quantity == 0 ? "highLightSales" : ""}>
          {quantity ?? "NA"}
          {quantity == 0 && <img className="alert_style" src={alertIcon} alt="" />}
        </span>
      </div>
      <div
        className="labor-codes-table-row-cell ml-20px d-flex align-items-center"
        style={{ borderRight: "1px solid #d1d1d1" }}
      >
        <input
          type="checkbox"
          id={`${product.key}-${laborCodeItem.siteLaborCodeId}-isTaxable`}
          defaultChecked={laborCodeItem.isTaxable}
          onChange={(event) => {
            const isTaxable = event.target.checked;
            Promise.all(
              siteLaborCodeIds.map((siteId) =>
                axios.patch(`/fc-labor-table/siteProductLaborCode/${siteId}`, { isTaxable }),
              ),
            );

            dispatch(editSiteProductLaborCode({ siteLaborCodeIds, isTaxable }));
            setIsTaxable(isTaxable);
          }}
          style={{ marginRight: "10px" }}
        />
        <label htmlFor={`${product.key}-${laborCodeItem.siteLaborCodeId}-isTaxable`} className="info-item">
          Taxable
        </label>
      </div>
      {territoryAccess && (
        <div className="d-flex margin-left-20 align-items-center">
          <Button
            variant="link"
            style={{ padding: "5px 10px", marginLeft: "20px", backgroundColor: "white" }}
            onClick={() => setShowEditLaborCodeModal(true)}
          >
            <img src={editIcon} alt="edit" width={16} height={16} />
          </Button>
          <Button
            variant="link"
            style={{ padding: "5px 10px", marginLeft: "20px", backgroundColor: "white" }}
            onClick={() => setShowDeleteLaborCodeModal(true)}
          >
            <img src={deleteIconBlue} alt="delete" width={16} height={16} />
          </Button>
        </div>
      )}

      {showEditLaborCodeModal && (
        <Modal
          title={"Edit Labor Code"}
          handleSave={() => {
            axios.post(`/fc-site-repo/add/laborCode`, {
              roomInfoIds: product.roomInfoIds,
              laborCodeId: laborCodeItem.laborCodeId,
              quantity,
              laborCodeModDesc: description,
              updatedBy: sub,
              layerId: layer.layerId,
              siteId,
              action: "old",
              isTaxable,
            });
            dispatch(editSiteProductLaborCode({ siteLaborCodeIds, laborCodeModDesc: description, quantity }));
            setShowEditLaborCodeModal(false);
          }}
          handleCancel={() => setShowEditLaborCodeModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText="Save"
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <div className="search-form-container__fields">
                <form className="search-form-container__fields__form">
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3 search-form-container__fields__form-group">
                      <InputField
                        type="number"
                        id="quantity"
                        label="Quantity"
                        placeholder={"Enter Quantity"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        disabled={false}
                        isRequired={false}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-8 col-lg-8 search-form-container__fields__form-group">
                      <InputField
                        type="text"
                        id="laborCodeDescEditable"
                        label={`Description`}
                        placeholder={"Enter Description"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        disabled={false}
                        isRequired={false}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        </Modal>
      )}

      {showDeleteLaborCodeModal && (
        <Modal
          title={"Remove Labor Code"}
          handleSave={() => {
            dispatch(
              deleteLaborCodeForProduct(
                {
                  roomInfoIds: product.roomInfoIds,
                  laborCodeId: laborCodeItem.laborCodeId,
                  layerId: layer.layerId,
                  siteId,
                  updatedBy: sub,
                },
                siteId,
              ),
            );
            setShowDeleteLaborCodeModal(false);
          }}
          handleCancel={() => setShowDeleteLaborCodeModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText={"Remove"}
          saveButtonClass={"btn-primary remove"}
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <p>
                Are you sure you want to remove <b>{laborCodeItem.laborCode}</b> from product <b>{product.key}</b> ?{" "}
              </p>
            </div>
          </>
        </Modal>
      )}
    </div>
  );
};

const ProductView = ({ project, layerLevelData, territoryAccess }) => {
  const dispatch = useDispatch();
  const { siteId } = useParams();
  const [isShowDeleteProductModel, setIsShowDeleteProductModel] = useState(false);
  const [isShowEditProductModel, setIsShowEditProductModel] = useState(false);
  const [deleteProductModelData, setDeleteProductModelData] = useState();
  const [editProductModelData, setEditProductModelData] = useState();
  const [laborCodeData, setLaborCodeData] = useState();
  const [selectedLayerData, setSelectedLayerData] = useState();
  const [isShowAddProductModal, setIsShowAddProductModal] = useState(false);
  const [isShowFloormapModal, setIsShowFloormapModal] = useState(false);
  const [pictureData, setPictureData] = useState();
  const [isShowEditFloorDetails, setIsShowEditFloorDetails] = useState(false);
  const [editFloorDetailsData, setEditFloorDetailsData] = useState();
  const [openAccordian, setOpenAccordian] = useState(false);
  const [laborCodeStyle, setLaborCodeStyle] = useState("");

  const [addProductData, setAddProductData] = useState({
    productName: "",
    actualUsage: "",
    category: "",
    salesNumber: "",
    manufacturer: "",
    department: "",
    categoryCode: "",
  });

  const [layerArray, setLayerArray] = useState([]);
  const [isAddingProduct, setIsAddingProduct] = useState(false);
  const [isDeletingProduct, setIsDeletingProduct] = useState(false);
  const [isUpdatingFloorDetails, setIsUpdatingFloorDetails] = useState(false);
  const [isAddingLaborCode, setIsAddingLaborCode] = useState(false);

  const laborCodesNode = useRef();
  const autoFocus = useRef(null);
  const autoFocusUsage = useRef(null);
  const { distinctLaborCodes, viewSite, stores } = useSelector((state) => state.siteRepo);
  const { sub } = useSelector((state) => state.loggedInUser);
  const { showSpinner } = useSelector((state) => state.spinner);
  const products = project.layerInfoList.flatMap((layer) => layer.rooms).flatMap((room) => room.products);
  const uniqProducts = uniqBy(products, "id");
  const cutSheetData = project.cutSheetData ?? [];

  useEffect(() => {
    dispatch(getlaborCodeOptions());
  }, []);

  useEffect(() => {
    let finalProductArray = [];
    project.layerInfoList.map((layer) => {
      let productsObj = {};
      let totalProducts = 0;
      const { productsObjUpdated, totalProductsUpdated, manualId } = getProductsObject(
        productsObj,
        totalProducts,
        layer.rooms,
        layer.projectName,
        layer.name,
        layer.layerId,
      );
      productsObj = productsObjUpdated;
      totalProducts = totalProductsUpdated;

      const productsArr = [];
      Object.keys(productsObj).forEach((product) => {
        productsObj[product].isShowAddLaborCodes = false;
        productsObj[product].selectedLaborCode = "";
        productsObj[product].selectedLaborCodeMetaData = null;
        productsObj[product].laborCodeQuantity = "";
        productsObj[product].key = product;
        productsObj[product].name = product;

        if (product.basePerimeter) {
          product.basePerimeter = product.basePerimeter / 12;
        }
        productsArr.push(productsObj[product]);
      });

      productsArr.map((labor) => {
        labor.siteLaborCodesData?.sort((a, b) => {
          const nameA = a.laborCode.toUpperCase();
          const nameB = b.laborCode.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });
      });

      const sortedProducts = sortBy(productsArr, [(p) => (p.rank === undefined ? 0 : Number(p.rank)), "key"]);

      if (cutSheetData?.length) {
        cutSheetData
          .filter(
            (cutSheetData) =>
              layer.shapeId === null || cutSheetData.shapeId === null || cutSheetData.shapeId === layer.shapeId,
          )
          .map((cutsheetItem) => {
            sortedProducts.map((product) => {
              if (cutsheetItem.productName === product.key) {
                product.cutSheetImage = cutsheetItem.cutSheetImage;
                product.linearLength = cutsheetItem.linearLength;
                product.layerCutSheetId = cutsheetItem.layerCutSheetId;
                if (cutsheetItem?.rolls?.length) {
                  product.rollWidth = cutsheetItem.rolls[0].width;
                }
              }
            });
          });
      }

      let productsArrObj = {};
      sortedProducts.map((item) => {
        productsArrObj[item.key] = item;
      });
      finalProductArray.push({ ...layer, productData: productsArrObj });
    });

    const finalData = [...finalProductArray].sort((a, b) => (a.name > b.name ? 1 : -1));
    setLayerArray(finalData);
  }, [project]);

  const handleLaborCodeLookup = (productKey, isShow, layerData) => {
    setLaborCodeStyle("expand-len");
    const tempLayerArr = JSON.parse(JSON.stringify(layerArray));
    tempLayerArr.map((layer) => {
      if (layerData.layerId === layer.layerId) {
        layer.productData[productKey].isShowAddLaborCodes = isShow;
        setLaborCodeData(layer);
      }
    });
    setLayerArray(tempLayerArr);
  };

  const handleLaborCodeValues = (e, value, prd, clickevn) => {
    setLaborCodeStyle("");
    if (autoFocus.current && value) {
      autoFocus.current.focus();
    }
    const laborDetails = JSON.parse(clickevn.target.dataset.selectedmetadata);
    const { key } = JSON.parse(prd);

    const prodData = JSON.parse(JSON.stringify(laborCodeData.productData));
    if (laborDetails.matchProdQuantity === "false") {
      prodData[key].selectedLaborCode = value;
      prodData[key].selectedLaborCodeMetaData = laborDetails;
    } else if (laborDetails.matchProdQuantity === "true") {
      if (laborDetails.unitType === "false") {
        prodData[key].selectedLaborCode = value;
        prodData[key].selectedLaborCodeMetaData = laborDetails;
        prodData[key].laborCodeQuantity = !prodData[key].actualUsage
          ? parseFloat(prodData[key].modActualUsage).toFixed(2)
          : parseFloat(prodData[key].actualUsage).toFixed(2);
      } else if (laborDetails.unitType === "true" && prodData[key].unit === "EA") {
        prodData[key].selectedLaborCode = value;
        prodData[key].selectedLaborCodeMetaData = laborDetails;
        prodData[key].laborCodeQuantity = !prodData[key].actualUsage
          ? parseFloat(prodData[key].modActualUsage).toFixed(2)
          : parseFloat(prodData[key].actualUsage).toFixed(2);
      } else if (laborDetails.unitType === "true" && prodData[key].unit !== "EA") {
        prodData[key].selectedLaborCode = value;
        prodData[key].selectedLaborCodeMetaData = laborDetails;
      }
    }

    const tempLayerArr = JSON.parse(JSON.stringify(layerArray));
    tempLayerArr.map((layer) => {
      if (laborCodeData.layerId === layer.layerId) {
        layer.productData = prodData;
        setLaborCodeData({ ...layer, productData: prodData });
      }
    });
    setLayerArray(tempLayerArr);
  };

  const handleQuantityChange = (key, e) => {
    const prodData = JSON.parse(JSON.stringify(laborCodeData.productData));
    prodData[key].laborCodeQuantity = e.target.value;

    const tempLayerArr = JSON.parse(JSON.stringify(layerArray));
    tempLayerArr.map((layer) => {
      if (laborCodeData.layerId === layer.layerId) {
        layer.productData = prodData;
      }
    });
    setLayerArray(tempLayerArr);
  };

  const addLaborCode = (data, layerId) => {
    if (isAddingLaborCode) {
      return;
    }
    const {
      roomInfoIds,
      selectedLaborCodeMetaData: { id },
      laborCodeQuantity,
    } = data;

    setIsAddingLaborCode(true);
    toast
      .promise(
        dispatch(
          addLaborCodeForProduct(
            {
              roomInfoIds,
              laborCodeId: id,
              quantity: parseFloat(laborCodeQuantity).toString(),
              createdBy: sub,
              updatedBy: sub,
              layerId,
              siteId,
              action: "new",
              isTaxable: stores[viewSite.storeNumber].laborCodes.find((lc) => lc.laborCodeId === Number(id))?.isTaxable,
            },
            siteId,
          ),
        ),
        {
          pending: "Adding Labor Code",
          success: "Labor code added successfully",
          error: "Could not add labor code, please try again.",
        },
      )
      .catch(() => {})
      .finally(() => setIsAddingLaborCode(false));
  };

  const handleDeleteProductModal = (isShow, product, layerId) => {
    setIsShowDeleteProductModel(isShow);
    if (isShow) {
      setDeleteProductModelData({ ...product, layerId });
    } else {
      setDeleteProductModelData({});
    }
  };

  const confirmDeleteProduct = () => {
    if (isDeletingProduct) {
      return;
    }
    const deleteProductRequestObj = {
      roomInfoIds: deleteProductModelData.roomInfoIds,
      layerCutSheetId: deleteProductModelData.layerCutSheetId,
      updatedBy: sub,
      siteId,
      layerId: deleteProductModelData.layerId,
    };
    setIsDeletingProduct(true);

    toast
      .promise(dispatch(removeProduct(deleteProductRequestObj, siteId)), {
        pending: "Removing Product",
        success: "Product removed successfully",
        error: "Could not remove product, please try again.",
      })
      .then(() => {
        handleDeleteProductModal(false);
      })
      .catch(() => {})
      .finally(() => setIsDeletingProduct(false));
  };

  const handleEditProductModal = (isShow, product, layerId) => {
    setIsShowEditProductModel(isShow);
    if (isShow) {
      setEditProductModelData({
        ...product,
        actualUsageEditable: product.modActualUsage
          ? product.modActualUsage.toFixed(2)
          : product.actualUsage
            ? product.actualUsage.toFixed(2)
            : "",
        layerId,
      });
    } else {
      setEditProductModelData({});
    }
  };

  const confirmEditProduct = () => {
    let actualUsageModified;
    let wasteModified;

    let productsObj = {};
    layerArray.map((layer) => {
      if (editProductModelData.layerId === layer.layerId) {
        productsObj = layer.productData;
      }
    });

    if (productsObj[editProductModelData.key].modActualUsage === null) {
      if (
        parseFloat(productsObj[editProductModelData.key].actualUsage)?.toFixed(2) ==
        parseFloat(editProductModelData.actualUsageEditable)
      ) {
        actualUsageModified = null;
        wasteModified = null;
      } else {
        actualUsageModified = parseFloat(editProductModelData.actualUsageEditable);
        if (editProductModelData.sellByBox) {
          wasteModified =
            ((parseFloat(actualUsageModified) - editProductModelData.netAreaSum) / editProductModelData.netAreaSum) *
            100;
        } else {
          wasteModified =
            ((editProductModelData.quantitySum - editProductModelData.netAreaSum) / editProductModelData.quantitySum) *
            100;
        }
      }
    } else {
      if (productsObj[editProductModelData.key].modActualUsage === editProductModelData.actualUsageEditable) {
        actualUsageModified = editProductModelData.modActualUsage;
        wasteModified = editProductModelData.modWaste;
      } else {
        actualUsageModified = parseFloat(editProductModelData.actualUsageEditable);
        if (editProductModelData.sellByBox) {
          wasteModified =
            ((parseFloat(actualUsageModified) - editProductModelData.netAreaSum) / editProductModelData.netAreaSum) *
            100;
        } else {
          wasteModified =
            ((editProductModelData.quantitySum - editProductModelData.netAreaSum) / editProductModelData.quantitySum) *
            100;
        }
      }
    }

    const editRequestObj = {
      roomInfoIds: editProductModelData.roomInfoIds,
      productName: editProductModelData.name,
      category: editProductModelData.type,
      modActualUsage: actualUsageModified,
      modWaste: wasteModified,
      salesNumber: editProductModelData.salesNumber,
      createdBy: "",
      updatedBy: sub,
      siteId,
      layerId: editProductModelData.layerId,
      layerCutSheetId: editProductModelData.layerCutSheetId,
      categoryCode: editProductModelData.categoryCode,
    };
    if (editProductModelData.unit && editProductModelData.rollWidth && actualUsageModified) {
      const rollWidth = editProductModelData.rollWidth;
      const rollWidthFeet = parseFloat(rollWidth.substring(0, rollWidth.indexOf("'")));
      const rollWidthInches = parseFloat(rollWidth.substring(rollWidth.indexOf("'") + 1, rollWidth.indexOf('"')));
      let usageValue;
      let feetValue;
      let inchesValue;
      if (editProductModelData.unit === "SY") {
        usageValue = (parseFloat(actualUsageModified / parseFloat(rollWidthFeet + "." + rollWidthInches)) * 9)?.toFixed(
          3,
        );
      } else {
        usageValue = parseFloat(actualUsageModified / parseFloat(rollWidthFeet + "." + rollWidthInches)).toFixed(3);
      }
      feetValue = parseFloat(usageValue.substring(0, usageValue.indexOf(".")));
      inchesValue = Math.round((usageValue - feetValue) / 0.0833);
      editRequestObj.linearLength = rollWidth + "x" + feetValue + "'" + inchesValue + '"';
    }

    dispatch(updateProduct(editRequestObj, siteId)).then(() => handleEditProductModal(false));
  };

  const handleEditProductDetailsFieldsChange = (e) => {
    const { value, id } = e.target;
    if (id === "actualUsage") {
      setEditProductModelData({ ...editProductModelData, actualUsageEditable: value });
    } else {
      setEditProductModelData({ ...editProductModelData, [id]: value });
    }
  };

  const handleAddProductModal = (isShow, layerId) => {
    if (isShow) {
      setIsShowAddProductModal(true);
      setSelectedLayerData(layerId);
    } else {
      setIsShowAddProductModal(false);
    }
  };

  const onProductSelection = (productData, isSelected) => {
    setOpenAccordian(true);
    if (isShowEditProductModel) {
      if (isSelected) {
        setEditProductModelData({
          ...editProductModelData,
          name: productData.productName,
          type: productData.category,
          salesNumber: productData.salesNumber,
          categoryCode: productData.categoryCode,
        });
      }
    } else {
      setTimeout(() => {
        if (autoFocusUsage.current && productData.productName) {
          autoFocusUsage.current.focus();
        }
      }, 100);
      if (isSelected) {
        setAddProductData({ ...productData, actualUsage: "" });
      } else {
        setAddProductData({});
      }
      handleAddProductModal(false);

      let tempLayerArray = JSON.parse(JSON.stringify(layerArray));
      tempLayerArray.map((layer) => {
        if (selectedLayerData === layer.layerId) {
          layer.isShowAddProductFields = true;
        }
      });
      setLayerArray(tempLayerArray);
    }
  };

  const onAddProductFieldsChange = (e) => {
    const { id, value } = e.target;
    setAddProductData({ ...addProductData, [id]: value });
  };

  const handleCancelFields = () => {
    let tempLayerArray = JSON.parse(JSON.stringify(layerArray));
    tempLayerArray.map((layer) => {
      if (selectedLayerData === layer.layerId) {
        layer.isShowAddProductFields = false;
      }
    });
    setLayerArray(tempLayerArray);
  };

  const confirmAddProduct = () => {
    var manualRoomId;
    layerArray.map((layer) => {
      if (selectedLayerData === layer.layerId) {
        layer.rooms?.map((room) => {
          if (room.manualRoom) {
            manualRoomId = room.roomId;
          }
        });
      }
    });

    const addProductObj = {
      layerId: selectedLayerData,
      createdBy: sub,
      updatedBy: sub,
      siteId,
      rooms: [
        {
          layerId: selectedLayerData,
          roomId: manualRoomId?.length ? manualRoomId : "",
          name: "Manually Added",
          type: "Manual",
          manualRoom: true,
          area: null,
          perimeter: null,
          products: [
            {
              roomInfoId: "",
              roomId: manualRoomId?.length ? manualRoomId : "",
              id: addProductData.productName,
              type: addProductData.category,
              createdBy: sub,
              actualUsage: parseFloat(addProductData.actualUsage).toString(),
              salesNumber: addProductData.salesNumber,
              siteLaborCodes: [],
              categoryCode: addProductData.categoryCode,
            },
          ],
        },
      ],
    };

    if (isAddingProduct) {
      return;
    }
    setIsAddingProduct(true);

    toast
      .promise(dispatch(addProduct(addProductObj, project.projectId)), {
        pending: "Adding Product",
        success: "Product added successfully",
        error: "Could not add product, please try again.",
      })
      .then(() => {
        let tempLayerArray = JSON.parse(JSON.stringify(layerArray));
        tempLayerArray.map((layer) => {
          if (selectedLayerData === layer.layerId) {
            layer.isShowAddProductFields = false;
          }
        });
        setLayerArray(tempLayerArray);
      })
      .catch(() => {})
      .finally(() => setIsAddingProduct(false));
  };

  const handleFloormapModal = (isShow, pictureData, name) => {
    if (isShow) {
      setIsShowFloormapModal(true);
      setPictureData({ data: pictureData, name });
    } else {
      setIsShowFloormapModal(false);
    }
  };

  const handleFloorDetailsModal = (isShow, name, layerId) => {
    setIsShowEditFloorDetails(isShow);
    if (isShow) {
      setEditFloorDetailsData({ floorName: name, layerId: layerId });
    } else {
      setEditFloorDetailsData({});
    }
  };

  const handleEditFloorDataFieldsChange = (e) => {
    const { id, value } = e.target;
    setEditFloorDetailsData({ ...editFloorDetailsData, [id]: value });
  };

  const confirmEditFloorDetails = () => {
    const {
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      projectDetailsList,
    } = viewSite;
    const editFloorDetailsReqObj = {
      siteId,
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      updatedBy: sub,
      projectDetailsList: projectDetailsList?.length
        ? projectDetailsList
            .filter((projectItem) => projectItem.mprojectId === project.mprojectId)
            .map((filteredProjectItem) => {
              const {
                projectId,
                layerInfoList,
                mprojectId,
                creatorM2Id,
                isArchived,
                lastUpdatedOn,
                ownerM2Id,
                revision,
                usedM2Id,
                size,
                name,
              } = filteredProjectItem;
              return {
                mprojectId,
                projectId,
                updateType: "old",
                name,
                updatedBy: sub,
                creatorM2Id,
                isArchived,
                lastUpdatedOn,
                ownerM2Id,
                revision,
                usedM2Id,
                size,
                updatedBy: sub,
                layerInfoList: layerInfoList?.length
                  ? layerInfoList
                      .filter((layerItem) => layerItem.layerId === editFloorDetailsData.layerId)
                      .map((filteredLayerItem) => {
                        return {
                          layerId: filteredLayerItem.layerId,
                          name: editFloorDetailsData.floorName,
                          mprojectId: filteredProjectItem.mprojectId,
                          projectName: name,
                          rooms: [],
                          updatedBy: sub,
                          shapeId: filteredLayerItem.shapeId,
                        };
                      })
                  : [],
              };
            })
        : [],
    };

    if (isUpdatingFloorDetails) {
      return;
    }
    setIsUpdatingFloorDetails(true);

    toast
      .promise(dispatch(submitCreateNewSite(editFloorDetailsReqObj, viewSite)), {
        pending: "Updating Floor Name",
        success: "Floor name updated successfully",
        error: "Could not update floor name, please try again.",
      })
      .then((res) => {
        handleFloorDetailsModal(false);
        dispatch(getSiteDetails(res.siteId));
      })
      .catch(() => {})
      .finally(() => setIsUpdatingFloorDetails(false));
  };

  return (
    <>
      <div className="accordion-items-container">
        <div className="col-12 accordion accordion-flush" id="project_floor_view">
          {layerArray.map((layer, index) => (
            <div className="accordion-item" key={layer.layerId}>
              <div className="accordion-row d-flex align-items-start align-items-md-center flex-column flex-md-row">
                <div className="col-auto layer-image-container d-none d-md-block">
                  <img
                    src={layer.pictureData ? layer.pictureData : imagePlaceHolder}
                    alt="..."
                    className="layer-image"
                    onClick={() =>
                      layer.pictureData ? handleFloormapModal(true, layer.pictureData, layer.name) : true
                    }
                  />
                </div>
                <div className="d-flex justify-content-between col-10 d-none d-md-flex">
                  <div className="d-flex align-items-center">
                    <span className="item-label-header">Floor Name:</span>
                    <span className="item-label-main item-label-header">{layer.name}</span>
                    {territoryAccess && (
                      <span>
                        <img
                          src={editIcon}
                          className="edit-floor"
                          alt="..."
                          onClick={() => handleFloorDetailsModal(true, layer.name, layer.layerId)}
                        />
                      </span>
                    )}
                  </div>

                  {territoryAccess && (
                    <div className="justify-content-end d-flex">
                      <Button variant="outline-primary" onClick={() => handleAddProductModal(true, layer.layerId)}>
                        Add Product
                      </Button>
                    </div>
                  )}
                </div>

                <div className="item justify-content-end expand d-none d-md-flex flex-grow-1">
                  <Button
                    className="accordion-button collapsed"
                    variant="link"
                    data-bs-toggle="collapse"
                    data-bs-target={`#flush-collapse-${layer.layerId}-${index}`}
                    aria-expanded={layer.layerId === layerLevelData.layerId || openAccordian ? "true" : "false"}
                    aria-controls={`flush-collapse-${layer.layerId}-${index}`}
                    onClick={() => true}
                  ></Button>
                </div>
              </div>

              <div
                id={`flush-collapse-${layer.layerId}-${index}`}
                className={`accordion-content-container accordion-collapse collapse ${layer.layerId === layerLevelData.layerId || openAccordian ? "show" : ""}`}
                aria-labelledby="flush-headingOne"
                data-bs-parent="#search-mq-results-accordion-parent"
              >
                <div className="d-flex flex-wrap product-container product-view">
                  <div className="col-12 accordion accordion-flush" id="search-mq-results-accordion-parent">
                    {layer?.isShowAddProductFields && (
                      <div className="container-fluid px-2 border-0 m-0 py-5">
                        <div className="search-form-container__fields">
                          <form className="search-form-container__fields__form">
                            <div className="row align-items-center">
                              <div className="col-12 col-sm-12 col-md-6 col-lg-2 search-form-container__fields__form-group">
                                <InputField
                                  type="text"
                                  id="salesNumber"
                                  label="Sales Number"
                                  fieldClasses="form-control search-form-container__fields__form-group__item"
                                  value={addProductData.salesNumber}
                                  disabled={true}
                                  isRequired={false}
                                />
                              </div>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-3 search-form-container__fields__form-group">
                                <InputField
                                  type="text"
                                  id="productName"
                                  label="Product Name"
                                  placeholder={"Enter Product Name"}
                                  fieldClasses="form-control search-form-container__fields__form-group__item"
                                  value={addProductData.productName}
                                  onChange={(e) => onAddProductFieldsChange(e)}
                                  disabled={false}
                                  isRequired={false}
                                />
                              </div>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-2 search-form-container__fields__form-group">
                                <InputField
                                  type="number"
                                  id="actualUsage"
                                  label={`Actual Usage`}
                                  placeholder={"Enter Actual Usage"}
                                  fieldClasses="form-control search-form-container__fields__form-group__item"
                                  value={addProductData.actualUsage}
                                  onChange={(e) => onAddProductFieldsChange(e)}
                                  disabled={false}
                                  isRequired={false}
                                  refVal={autoFocusUsage}
                                />
                              </div>

                              <div className="col-12 col-sm-12 col-md-2 col-lg-1 search-form-container__fields__form-group m-md-0">
                                <Button
                                  className="w-100"
                                  onClick={() => confirmAddProduct()}
                                  disabled={
                                    !addProductData.actualUsage || !addProductData.productName || isAddingProduct
                                  }
                                >
                                  Add
                                </Button>
                              </div>
                              <div className={`col-12 col-sm-12 col-md-3 col-lg-2`}>
                                <Button
                                  variant="outline-primary"
                                  className="w-100"
                                  onClick={() => handleAddProductModal(true, layer.layerId)}
                                >
                                  Product Lookup
                                </Button>
                              </div>
                              <div className="col-12 col-sm-12 col-md-2 col-lg-1">
                                <Button
                                  variant="outline-primary"
                                  className="w-100"
                                  onClick={() => handleCancelFields()}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}

                    {layer.productData && Object.keys(layer.productData)?.length ? (
                      Object.keys(layer.productData).map((productKey, index) => {
                        const product = layer.productData[productKey];
                        const collapseId = generateUUID();
                        return (
                          <div className="accordion-item mt-0" key={index}>
                            <div className="product-name justify-content-between">
                              <span className="product-name-value d-flex align-items-center">
                                <span>{product.name}</span>
                              </span>
                            </div>
                            <div className="accordion-row d-flex align-items-start flex-column">
                              <div className="d-flex align-items-start align-items-md-center flex-column flex-md-row w-100 product-attribute-container">
                                <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute sales-number col-1 seperator">
                                  <span className="label">SW Sales Number</span>
                                  <span className={`${!product.salesNumber ? "highLightSales" : ""}`}>
                                    {product.salesNumber ? product.salesNumber : "NA"}
                                    {!product.salesNumber && (
                                      <CustomTooltip placement="top" trigger="hover" text={"Sales Number is empty"}>
                                        <span>
                                          <img className={`alert_style ${""} `} src={alertIcon} />
                                        </span>
                                      </CustomTooltip>
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute category col-2 seperator">
                                  <span className="label">SW Product Category</span>
                                  <span>{product.type ? product.type : "NA"}</span>
                                </div>
                                <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute usage seperator  col-md-2 col-lg-auto">
                                  <span className="label d-flex justify-content-between align-items-center">
                                    Actual Usage {product.unit ? `(${product.unit})` : ""}{" "}
                                    {product.modActualUsage ? (
                                      <CustomTooltip
                                        placement="top"
                                        trigger="hover"
                                        text={`Original Actual Usage: ${product.actualUsage ? product.actualUsage.toFixed(2) : "NA"}`}
                                      >
                                        <img src={historyIcon} className="history_icon" />
                                      </CustomTooltip>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                  <span className={`${product.actualUsage == "0" ? "highLightSales" : ""}`}>
                                    {product.modActualUsage
                                      ? product.modActualUsage.toFixed(2)
                                      : product.actualUsage || product.actualUsage == "0"
                                        ? product.actualUsage.toFixed(2)
                                        : "NA"}
                                    {product.actualUsage == "0" && (
                                      <CustomTooltip placement="top" trigger="hover" text={"Actual Usage is 0"}>
                                        <span>
                                          <img className="alert_style" src={alertIcon} />
                                        </span>
                                      </CustomTooltip>
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute linear-length seperator  col-md-2 col-lg-auto">
                                  <span className="label">Linear Length {product.unit ? `(${product.unit})` : ""}</span>
                                  <span>{product.linearLength ? product.linearLength : "NA"}</span>
                                </div>
                                <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute net-area seperator  col-md-2 col-lg-auto">
                                  <span className="label">Net Area {product.unit ? `(${product.unit})` : ""}</span>
                                  <span>{product.netAreaSum ? product.netAreaSum.toFixed(2) : "NA"}</span>
                                </div>
                                <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute perimeter seperator  col-md-2 col-lg-auto">
                                  <span className="label">
                                    Room Perimeter {product.unit ? `(${product.unit})` : ""}
                                  </span>
                                  <span>{product.basePerimeterSum ? product.basePerimeterSum.toFixed(2) : "NA"}</span>
                                </div>
                                <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute waste  col-md-2 col-lg-auto">
                                  <span className="label d-flex justify-content-between align-items-center">
                                    Waste{" "}
                                    {product.modWaste ? (
                                      <CustomTooltip
                                        placement="top"
                                        trigger="hover"
                                        text={`Original Waste: ${product.overallWaste ? product.overallWaste?.toFixed(2) + "%" : "NA"}`}
                                      >
                                        <img src={historyIcon} className="history_icon" />
                                      </CustomTooltip>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                  <span>
                                    {product.modWaste
                                      ? product.modWaste.toFixed(2) + "%"
                                      : product.overallWaste
                                        ? product.overallWaste?.toFixed(2) + "%"
                                        : "NA"}
                                  </span>
                                </div>
                                <div className="item justify-content-end expand d-none d-md-flex flex-grow-1">
                                  {territoryAccess && (
                                    <>
                                      <Button
                                        variant="link"
                                        className="p-1"
                                        onClick={() => handleEditProductModal(true, product, layer.layerId)}
                                      >
                                        <img src={editIcon} alt="..." />
                                      </Button>
                                      <Button
                                        variant="link"
                                        className="p-1 delete-prod-icon"
                                        onClick={() => handleDeleteProductModal(true, product, layer.layerId)}
                                      >
                                        <img src={deleteIconBlue} alt="..." />
                                      </Button>
                                    </>
                                  )}
                                  <Button
                                    className="accordion-button collapsed"
                                    variant="link"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#flush-collapse-${collapseId}`}
                                    aria-expanded="false"
                                    aria-controls={`flush-collapse-${collapseId}`}
                                    onClick={() => true}
                                  ></Button>
                                </div>
                              </div>
                              <div
                                className={`labor-codes-container d-flex w-100 flex-column ${product.isShowAddLaborCodes && laborCodeStyle}`}
                              >
                                <div
                                  className={`labor-codes-header ${
                                    product.siteLaborCodes?.length ? "exists" : "empty"
                                  }`}
                                >
                                  {territoryAccess && (
                                    <span
                                      onClick={() => handleLaborCodeLookup(product.name, true, layer)}
                                      style={{ display: "inline-flex" }}
                                    >
                                      <img src={addIcon} alt="..." className="labor-codes-header-icon" />
                                    </span>
                                  )}
                                  <span>Labor Codes</span>
                                </div>
                                {product.isShowAddLaborCodes && (
                                  <div className="d-flex flex-column px-4 mx-3 py-4 px-md-0 mx-md-0 labor-codes-fields-container">
                                    <div className="search-form-container__fields">
                                      <form className="search-form-container__fields__form">
                                        <div className="row align-items-center">
                                          <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group m-md-0">
                                            <MultiSelectInput
                                              inputRef={laborCodesNode}
                                              options={
                                                distinctLaborCodes
                                                  ? distinctLaborCodes.filter(
                                                      (laborCodeItem) =>
                                                        !product.siteLaborCodes.includes(laborCodeItem.laborCode),
                                                    )
                                                  : []
                                              }
                                              defaultValue="Select any labor code"
                                              handleSelectInput={handleLaborCodeValues}
                                              selectedValues={
                                                product.selectedLaborCode ? [product.selectedLaborCode] : []
                                              }
                                              isLookup={true}
                                              metaData={JSON.stringify(product)}
                                              isCloseAfterSelection={true}
                                            />
                                          </div>
                                          <div className="col-12 col-sm-12 col-md-6 col-lg-2 search-form-container__fields__form-group m-md-0">
                                            <InputField
                                              type="number"
                                              id="quantity"
                                              placeholder={"Enter Quantity"}
                                              fieldClasses="form-control search-form-container__fields__form-group__item"
                                              value={product.laborCodeQuantity}
                                              onChange={(e) => handleQuantityChange(product.name, e)}
                                              disabled={false}
                                              isRequired={false}
                                              refVal={autoFocus}
                                            />
                                          </div>
                                          <div className="col-12 col-sm-12 col-md-2 col-lg-2 search-form-container__fields__form-group m-md-0">
                                            <Button
                                              className="w-100"
                                              onClick={() => addLaborCode(product, layer.layerId)}
                                              disabled={
                                                !product.selectedLaborCode ||
                                                !product.laborCodeQuantity ||
                                                product?.laborCodeQuantity <= 0 ||
                                                isAddingLaborCode
                                              }
                                            >
                                              Add
                                            </Button>
                                          </div>
                                          <div className="col-12 col-sm-12 col-md-2 col-lg-2">
                                            <Button
                                              variant="outline-primary"
                                              className="w-100"
                                              onClick={() => handleLaborCodeLookup(product.name, false, layer)}
                                            >
                                              Cancel
                                            </Button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                )}
                                {product.siteLaborCodes?.length > 0 ? (
                                  <div style={{ marginLeft: "81px", padding: "0", width: "fit-content" }}>
                                    {product.siteLaborCodesData.map((laborCodeItem) => (
                                      <ProductLaborCodeRow
                                        key={`${product.key}-${laborCodeItem.laborCode}`}
                                        {...{ layer, product, laborCodeItem, territoryAccess }}
                                      />
                                    ))}
                                  </div>
                                ) : (
                                  <div className="labor-codes-no-codes">
                                    <span>No labor Code exists</span>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div
                              id={`flush-collapse-${collapseId}`}
                              className="accordion-content-container accordion-collapse collapse"
                              aria-labelledby="flush-headingOne"
                              data-bs-parent="#productsViewAccordionParent"
                            >
                              <div className="d-flex flex-wrap product-container">
                                {product.rooms?.length > 0 ? (
                                  product.rooms.map((room, roomId) => (
                                    <div className="product-card col-11 col-md-5 col-lg-3" key={roomId}>
                                      <div className="product-card__heading-container align-items-center">
                                        <div className="d-flex align-items-center overflow-hidden">
                                          <img src={roomIcon} alt="..." className="product-icon" />
                                          <span className="product-card__product-name">{room.name}</span>
                                        </div>
                                      </div>
                                      <div className="product-card__seperator" />
                                      <div className="product-card__body flex-column">
                                        <div className="d-flex flex-row justify-content-between mb-4">
                                          <span className="product-attr-label">Area</span>
                                          <span>{room.area ? room.area : "NA"}</span>
                                        </div>
                                        <div className="d-flex flex-row justify-content-between mb-4">
                                          <span className="product-attr-label">Perimeter</span>
                                          <span>{room.perimeter ? room.perimeter : "NA"}</span>
                                        </div>
                                        <div className="d-flex flex-row justify-content-between">
                                          <span className="product-attr-label">Products</span>
                                          <span>{room.productsLength ? room.productsLength : "NA"}</span>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <h1>No rooms available in this floor. Consider adding one!</h1>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : showSpinner ? (
                      ""
                    ) : (
                      <>
                        <div className="d-flex w-100 align-items-center justify-content-center">
                          <div className="alert alert-warning no-rooms-info mt-4" role="alert">
                            No products available. Consider adding one!
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {cutSheetData?.some((cutSheet) => cutSheet.cutSheetImage) && (
        <div className="container-fluid search-form-container cutsheets-container">
          <div className="search-form-container__title d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <span className="search-form-container__title--text">Cut Sheets</span>
            </div>
          </div>
          <div className="d-flex flex-wrap">
            {cutSheetData
              .filter((cutSheet) => cutSheet.cutSheetImage)
              .map(({ productName, cutSheetImage }) => (
                <CutSheet productName={productName} image={`data:image/jpeg;base64,${cutSheetImage}`} />
              ))}
          </div>
        </div>
      )}
      <CutMeasurements
        cutSheetData={cutSheetData}
        productsData={uniqProducts}
        projectId={project.projectId}
        territoryAccess={territoryAccess}
      />
      {isShowEditFloorDetails && (
        <Modal
          title={"Edit Floor Name"}
          handleSave={confirmEditFloorDetails}
          handleCancel={() => handleFloorDetailsModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText={"Save"}
          isSaveBtnDisabled={isUpdatingFloorDetails}
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <div className="search-form-container__fields">
                <form
                  className="search-form-container__fields__form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    confirmEditFloorDetails();
                  }}
                >
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                      <InputField
                        type="text"
                        id="floorName"
                        label="Floor Name"
                        placeholder={"Enter Floor Name"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={editFloorDetailsData.floorName || ""}
                        onChange={(e) => handleEditFloorDataFieldsChange(e)}
                        disabled={false}
                        isRequired={false}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        </Modal>
      )}

      {isShowAddProductModal && (
        <Modal
          title={"Add Product"}
          handleCancel={() => handleAddProductModal(false)}
          size={"xl"}
          sectionName={""}
          closeButtonText={"Cancel"}
          rootClass={"add-product-modal"}
        >
          <>
            <ProductLookup onProductSelectionCallback={onProductSelection} isHideSearchAfterSelection={true} />
          </>
        </Modal>
      )}

      {isShowEditProductModel && (
        <Modal
          title={"Edit Product Details"}
          handleSave={confirmEditProduct}
          handleCancel={() => handleEditProductModal(false)}
          size={"xl"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText="Save"
          rootClass={"edit-product-modal"}
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <div className="search-form-container__fields">
                <form className="search-form-container__fields__form">
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-5 search-form-container__fields__form-group">
                      <InputField
                        type="text"
                        id="name"
                        label="Product Name"
                        placeholder={"Enter Product Name"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={editProductModelData.name}
                        onChange={(e) => handleEditProductDetailsFieldsChange(e)}
                        disabled={false}
                        isRequired={false}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-5 search-form-container__fields__form-group">
                      <InputField
                        type="number"
                        id="actualUsage"
                        label={`Actual Usage ${editProductModelData.unit ? "( " + editProductModelData.unit + " )" : ""}`}
                        placeholder={"Enter Actual Usage"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={editProductModelData.actualUsageEditable}
                        onChange={(e) => handleEditProductDetailsFieldsChange(e)}
                        disabled={false}
                        isRequired={false}
                      />
                    </div>
                  </div>
                  <ProductLookup onProductSelectionCallback={onProductSelection} isHideSearchAfterSelection={true} />
                </form>
              </div>
            </div>
          </>
        </Modal>
      )}

      {isShowDeleteProductModel && (
        <Modal
          title={"Remove Product"}
          handleSave={confirmDeleteProduct}
          handleCancel={() => handleDeleteProductModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText={"Remove"}
          saveButtonClass={"btn-primary remove"}
          isSaveBtnDisabled={isDeletingProduct}
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <p>
                Are you sure you want to remove <b>{deleteProductModelData.key}</b> ?{" "}
              </p>
            </div>
          </>
        </Modal>
      )}

      {isShowFloormapModal && (
        <Modal
          title={pictureData.name}
          handleSave={() => {}}
          handleCancel={() => handleFloormapModal(false)}
          size={"lg"}
          sectionName={""}
          bodyClass={"account-lookup-search-form"}
        >
          <>
            <img src={pictureData.data} alt="..." className="col-12 px-1 px-md-2" />
          </>
        </Modal>
      )}
    </>
  );
};

export default ProductView;
